import React, { useState, useRef } from "react";
import InputField from "../InputField/InputField";
import TextareaField from "../TextareaField/TextareaField";
import "./Enquiry.styles.css";

import { Formik } from "formik";
import * as Yup from 'yup'
import ReCAPTCHA from "react-google-recaptcha";
import * as Constant from '../../lib/constant';
import { Slide, toast } from 'react-toastify';
import Axios from '../../lib/axios/axiosInstance';

const Enquiry = ({ productDetail }) => {
  const grecaptchaObject = window.grecaptcha;
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const recaptchaRef = useRef(null)
  const enquiryFormData = {
    userName: '',
    userEmail: '',
    userMobile: '',
    message: ''
  }

  function onReCAPTCHAChange(value) {
    setCaptchaVerified(value)
  }

  const submitForm = async (values, resetForm) => {
    if (!captchaVerified) {
      toast.error('Captcha not verified!', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 4000,
        transition: Slide
      })
      return;
    }
    var val = {
      message: {...values, matname: productDetail?.matname}
    }

    await Axios.post(`/product/enquiry/${productDetail?.matnum}`, val)
      .then(async (response) => {
        if (response?.data?.success) {
          toast.success('Enquiry sent successfully!', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
            transition: Slide
          });
          resetForm();
        } else {
          toast.error('Something went wrong', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
            transition: Slide
          })
        }
      })
  }

  return (
    <div className="product-tabs-content-inner clearfix">
      <h4>
        <i className="icon-speech icons" style={{ fontSize: "x-large" }}></i> Should
        you need more information on the product, kindly write your details to
        us.
      </h4>
      <Formik
        initialValues={enquiryFormData}
        validationSchema={Yup.object().shape({
          userName: Yup.string()
            .required('Name is required'),
          userEmail: Yup.string()
            .email("Enter valid email")
            .required('Email is required'),
          userMobile: Yup.number()
            .required('Mobile number is required'),
          message: Yup.string()
            .required('Please add message'),
        })}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          // console.log("values", values);
          submitForm(values, resetForm);
          setSubmitting(false);
        }}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
          } = props;
          return (

            <form className="comment-form" method="post" id="postComment" onSubmit={handleSubmit}>
              <InputField
                Type="text"
                Name="userName"
                Labels="Name"
                value={values.userName}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.userName}
                className={"field mb-3" + (errors.userName && touched.userName) && 'is-invalid'}
              />
              <InputField
                Type="text"
                Name="userEmail"
                value={values.userEmail}
                onChange={handleChange}
                onBlur={handleBlur}
                Labels="Email"
                isInvalid={!!errors.userName}
                className={"field mb-3" + (errors.userName && touched.userEmail) && 'is-invalid'}
              />
              <InputField
                Type="number"
                Name="userMobile"
                value={values.userMobile}
                onChange={handleChange}
                onBlur={handleBlur}
                Labels="Contact No."
                isInvalid={!!errors.userMobile}
                className={"field mb-3" + (errors.userMobile && touched.userMobile) && 'is-invalid'}
              />
              <div className="clear"></div>
              <TextareaField
                Labels="Enquiry"
                Rows="5"
                Name="message"
                Cols="50"
                style={{ border: '1px solid black' }}
                value={values.message}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.message}
                className={"field aw-blog-comment-area" + (errors.message && touched.message) && 'is-invalid'}
              />
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={Constant.ReCAPTCHA_SITE_KEY}
                grecaptcha={grecaptchaObject}
                // size='invisible'
                onChange={onReCAPTCHAChange}
              />
              <div style={{ width: "96%" }} className="button-set">
                {//<input type="hidden" value="1" name="blog_id" />
                }
                <button type="submit" className="bnt-comment">
                  <span>
                    <span>Submit</span>
                  </span>
                </button>
              </div>
            </form>
          )
        }}
      </Formik>
    </div>
  );
};

export default Enquiry;
